module.exports = __webpack_public_path__ + "img/flag-green.9d302130.svg";